import { render, staticRenderFns } from "./TeamEdit.vue?vue&type=template&id=06d089aa"
import script from "./TeamEdit.vue?vue&type=script&lang=js"
export * from "./TeamEdit.vue?vue&type=script&lang=js"
import style0 from "./TeamEdit.vue?vue&type=style&index=0&id=06d089aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports